import _ from 'lodash';

/**
 * This cache history is used to determine if a request had previously gone
 * out to the network or not. This is used to ensure that a component will go
 * out to the network at least once for every named query.
 */
const fetchHistoryCache = {};

// Crude method for generating unique keys based on queries
export const generateHistoryCacheKey = (operationName, variables) => {
  return JSON.stringify({ n: operationName, v: variables || {} });
};

export const storeRequestHistory = (operationName, variables) => {
  const key = generateHistoryCacheKey(operationName, variables);
  fetchHistoryCache[key] = true;

  return fetchHistoryCache;
};

/**
 * When this is used with a component for its fetchPolicy, it will ensure that
 * the first request goes out to the network while loading from the cache
 * if it is available. Any subsequent request will only go to the cache. This
 * makes sure that the client always has the freshest data while maintaining
 * fast loading speeds.
 */
export const hasRetrievedFromNetwork = (query, variables) => {
  const queryName = _.get(query, ['definitions', 0, 'name', 'value']);
  const key = generateHistoryCacheKey(queryName, variables);

  return Boolean(fetchHistoryCache[key]);
};

export const cacheOrNetworkFirst = (query, variables) => {
  return hasRetrievedFromNetwork(query, variables)
    ? 'cache-first'
    : 'cache-and-network';
};
